import { hasPermissionFunction } from 'src/helper/HasPermission'
import { PERMISSION_FRAUD } from 'src/helper/Permission'

export const isStatus = (label: string, value: string, status = false, disabled = false, customStyles: any = null) => {
  const styles = {
    borderRadius: '5px',
    color: 'white',
    padding: '2px 7px',
    fontSize: 14,
    textAlign: 'center',
    ...customStyles,
  }

  const success = {
    backgroundColor: disabled ? 'unset' : '#22ee65',
    ...styles,
  }

  const confidence = {
    backgroundColor: disabled ? 'unset' : 'blue',
    ...styles,
  }

  const error = {
    backgroundColor: disabled ? 'unset' : 'red',
    ...styles,
  }

  const pending = {
    backgroundColor: disabled ? 'unset' : 'orange',
    ...styles,
  }
  const pending_intense = {
    backgroundColor: disabled ? 'unset' : '#FF6600', // Un naranja más saturado y oscuro
    ...styles,
  }

  const yellow_status_operation = {
    backgroundColor: '#ffd600',
    ...styles,
  }

  const violet = {
    backgroundColor: 'rgb(103, 57, 230)',
    ...styles,
  }

  const permissionAnalysisStyles = hasPermissionFunction('item', PERMISSION_FRAUD)
  ? {
      display: 'flex',
      alignItems: 'center',
      padding: '0px 2px 0 7px',
    }
  : {};

  const analysis = {
    ...styles,
    ...pending_intense,
    ...permissionAnalysisStyles
  }

  const statusOptions: {
    [key: string]: { backgroundColor: string; borderRadius: string; color: string; padding: string }
  } = {
    // Estados donde no hay que hacer nada (VERDE)
    CLOSED: success,
    CONFIRMED: success,
    CONFIRMADO: success,
    INVOICED: success,
    EMITIDO: success,
    ISSUED: success,
    PAID: success,
    PAGO: success,
    NOT_REQUIRED: success,
    REINVOICED: success,
    BILLED: success,
    SENT: success,
    RESERVED: success,
    'IN RSV': success,
    APPROVED: success,
    MANUALLY_APPROVED: success,
    INIT_CHECKOUT: success,
    CASH_PAYMENT: success,
    FLIGHT_BOOKING_COMPLETED: success,
    UNAPPLIED:success,
    CONFIRMED_UNAPPLIED:success,
    APPLIED: success,
    PARTIAL_INVOICED: success,
    GENERATED: success,

    // Estados intermedios (AZUL)
    OPEN: confidence,
    GUARANTEED: confidence,
    GARANTIZADO: confidence,
    INVOICE_IN_PROGRESS: confidence,
    INVOICE_REQUESTED: confidence,
    SOLICITUD_EMISION: confidence,
    PROCESSING: confidence,
    PREBOOKED: confidence,
    IN_PROCESS: confidence,

    IN_REVIEW: analysis,
    FRAUD_ANALYSIS: analysis,
    CREDIT_GENERATED:confidence,
    CREDIT_APPLIED:confidence,
    REQUESTED:confidence,
    IN_PROGRESS:confidence,

    // Estados que necesitan intervencion (AMARILLOS)
    PENDING: pending,
    PARTIAL_REFUND: pending,
    REFUND_IN_PROGRESS: pending,
    UNPAID: pending,
    PENDING_BILLING: pending,
    PARTIALLY_PAID: pending,
    CREATED: pending,
    PENDING_RESERVATION: pending,
    PENDIENTE_EMISION: pending,
    PAYMENT_IN_PROCESS: pending,
    CANCELLATION_IN_PROGRESS: pending,
    VOID_IN_PROGRESS: pending,
    PENDING_OPERATION: pending,
    PREBOOKING_IN_PROGRESS: pending,
    CAPTURE_IN_PROGRESS: pending,
    CONFIRMATION_IN_PROGRESS: pending,
    AUTHORIZATION_IN_PROGRESS: pending,
    DUE:pending,
    AVAILABLE: pending,

    ON_SITE: yellow_status_operation,

    CROSSELL_SELECTED: pending_intense,
    FRAUD_REVITION: pending_intense,
    PAID_WITHOUR_FEE: pending_intense,
    FINISHED: pending_intense,
    FINALIZED: pending_intense,
    PARTIALLY_APPLIED: pending_intense,

    CREDIT_NOT_GENERATED:yellow_status_operation,

    'PRE-RESERVATION': pending,
    ON_REQUEST: pending,

    // Estados finales de rechazo (ROJO)
    DELETED: error,
    VOID: error,
    CANCELLED: error,
    CANCEL_PROVIDER: error,
    CANCELADO: error,
    CANCELLED_COST: error,
    ERROR: error,
    FRAUD: error,
    FRAUDE: error,
    SESSION_EXPIRED: error,
    SESSION_CLOSED: error,
    EXPIRED: error,
    CASH_PAYMENT_ABANDONED: error,
    BOOKING_REJECTED: error,
    PAYMENT_REJECTED: error,
    PREBOOKING_FAILED: error,
    REFUNDED: error,
    REEMBOLSO: error,
    REJECTED: error,
    MANUALLY_DISAPPROVED: error,
    FAILED_INVOICED: error,
    EMISION_FALLIDA: error,
    UNDEFINED: error,
    DUPLICATED_RECOVERED: error,
    ROLLBACK_ERROR: error,
    PREBOOKING_ERROR: error,
    DEFEATED: error,
    INVALIDATED: error,

    //(VIOLETA)
    INFORME_DE_PAGO: violet,
    AFTER_SALES: violet,
    AFTER_SALES_HIDDEN: violet
  }

  if (label === 'status' || label === 'Estado' || status || label === 'Status') {
    const valueAux = value || 'PENDING'
    return statusOptions?.[valueAux]
  }
}
